export const MyShortOffersBaseRoute = "/mein-remindme/angebote";

export const stromwechselUrl = "/strompreisvergleich";
export const gaswechselUrl = "/gaspreisvergleich";

export const gasOffer = "/tarifoptimierung?categoryType=GAS";
export const electricityOffer = "/tarifoptimierung?categoryType=ELECTRICITY";
export const heatpumpOffer = "/tarifoptimierung?categoryType=HEATPUMP";
